import { isEqual } from 'lodash'
import React from 'react'

export function useDeepCompareMemoize<T>(value: T): T {
  const previousValue = React.useRef<T>(undefined)

  if (!isEqual(value, previousValue.current)) {
    previousValue.current = value
  }

  return previousValue.current
}
